import axios from "axios";
import * as Types from "../data-types/api-client/api-products";
import * as Contacts from "../data-types/api-client/api-contacts";
import { ApiUrl } from "../data-types/api-client/api-url";

/** Fetch Provision data */
export const fetchProvisionData = async (): Promise<Types.RentProvision> => {
  const response = await axios.get(ApiUrl.ProductsApiUrl);
  return response.data;
};

/** Fetch Contact data */
export const fetchContactData = async (): Promise<Contacts.ContactData> => {
  const response = await axios.get(ApiUrl.ContactsApiUrl);
  return response.data;
};

// /** Fetch all categories */
// export const fetchCategories = async (): Promise<Category[]> => {
//   const response = await axios.get("/api/categories");
//   return response.data;
// };

// /** Fetch all products */
// export const fetchProducts = async (): Promise<ProductItem[]> => {
//   const response = await axios.get("/api/products");
//   return response.data;
// };

// /** Fetch all services */
// export const fetchServices = async (): Promise<ServiceItem[]> => {
//   const response = await axios.get("/api/services");
//   return response.data;
// };

// /** Fetch entire catalog (tabs, categories, products, and services) */
// export const fetchCatalog = async (): Promise<CatalogData> => {
//   const response = await axios.get("/api/products");
//   return response.data;
// };

// /** Create a new category */
// export const createCategory = async (category: Category): Promise<Category> => {
//   const response = await axios.post("/api/categories", category);
//   return response.data;
// };

// /** Create a new product */
// export const createProduct = async (
//   product: ProductItem
// ): Promise<ProductItem> => {
//   const response = await axios.post("/api/products", product);
//   return response.data;
// };

// /** Create a new service */
// export const createService = async (
//   service: ServiceItem
// ): Promise<ServiceItem> => {
//   const response = await axios.post("/api/services", service);
//   return response.data;
// };

// /** Update a category */
// export const updateCategory = async (
//   id: string,
//   category: Partial<Category>
// ): Promise<Category> => {
//   const response = await axios.put(`/api/categories/${id}`, category);
//   return response.data;
// };

// /** Update a product */
// export const updateProduct = async (
//   id: string,
//   product: Partial<ProductItem>
// ): Promise<ProductItem> => {
//   const response = await axios.put(`/api/products/${id}`, product);
//   return response.data;
// };

// /** Update a service */
// export const updateService = async (
//   id: string,
//   service: Partial<ServiceItem>
// ): Promise<ServiceItem> => {
//   const response = await axios.put(`/api/services/${id}`, service);
//   return response.data;
// };

// /** Delete a category */
// export const deleteCategory = async (id: string): Promise<void> => {
//   await axios.delete(`/api/categories/${id}`);
// };

// /** Delete a product */
// export const deleteProduct = async (id: string): Promise<void> => {
//   await axios.delete(`/api/products/${id}`);
// };

// /** Delete a service */
// export const deleteService = async (id: string): Promise<void> => {
//   await axios.delete(`/api/services/${id}`);
// };
